import React, { Component } from "react";

export class Information extends Component {
  render() {
    return (
      <div id={this.props.data ? this.props.data.id : 'loading...'}>
        <div className="container">
          <div className="row">
            {this.props.data?.textLeft ?
              <div>
                <div className="col-xs-12 col-md-6">
                  <div className="section-title">
                    <h2>{this.props.data ? this.props.data.h2 : 'loading...'}</h2>
                    <p>{this.props.data ? this.props.data.paragraph : 'loading...'}</p>
                  </div>
                </div>
                <div className="col-xs-12 col-md-6"> <img src={this.props.data ? this.props.data.img : 'loading...'} className="img-responsive" alt="" /> </div>
              </div>
              :
              <div>
                 <div className="col-xs-12 col-md-6"> <img src={this.props.data ? this.props.data.img : 'loading...'} className="img-responsive" alt="" /> </div>
                <div className="col-xs-12 col-md-6">
                  <div className="section-title">
                    <h2>{this.props.data ? this.props.data.h2 : 'loading...'}</h2>
                    <p>{this.props.data ? this.props.data.paragraph : 'loading...'}</p>
                  </div>
                </div>
              </div>
            }
          </div>
        </div>
      </div>


    );
  }
}

export default Information;
